import React, { useRef } from 'react';

import { CSSTransition, TransitionGroup } from 'react-transition-group';

import { useAppDispatch, useAppSelector } from '@pkg/hooks';

import { setSearchEmoji } from '../../../../store/actions/picker';
import YatHorizontalScrollContainer from '../../../Layout/HorizontalScrollContainer';
import YatAddEmojiButton from '../../AddEmojiButton/AddEmojiButton';

import './SearchResult.scss';

const YatPickerSearchResult = () => {
    const dispatch = useAppDispatch();
    const nodeRef = useRef(null);
    const { currentIndex, searchResult } = useAppSelector(({ picker }) => picker);

    return (
        <div className="yat-picker-search-result">
            <YatHorizontalScrollContainer>
                <div className="yat-picker-search-result__inner">
                    <ul
                        id="yat-picker-search-result__list"
                        className="yat-picker-search-result__list"
                        role="listbox"
                        aria-orientation="horizontal"
                    >
                        <li className="yat-picker-search-result__padding-spacer" aria-hidden="true" />
                        <TransitionGroup component={null}>
                            {searchResult.map((e, i) => (
                                <CSSTransition
                                    key={i}
                                    timeout={200}
                                    classNames="emoji-icon"
                                    unmountOnExit
                                    nodeRef={nodeRef}
                                >
                                    <li
                                        id={`search-result-emoji-${i}`}
                                        key={i}
                                        className={`yat-picker-search-result__emoji ${
                                            currentIndex === i ? ' yat-picker-search-result__emoji--selected' : ''
                                        }`}
                                        tabIndex={-1}
                                        role="option"
                                        aria-selected={currentIndex === i ? 'true' : 'false'}
                                        onMouseOver={() =>
                                            dispatch(setSearchEmoji({ newIndex: i, newIndexAffectsInput: false }))
                                        }
                                    >
                                        <YatAddEmojiButton
                                            emoji={e[0]}
                                            emojiName={e[1]}
                                            large={true}
                                            keepInputFocus={true}
                                            tabIndex={-1}
                                        />
                                    </li>
                                </CSSTransition>
                            ))}
                        </TransitionGroup>
                    </ul>
                </div>
            </YatHorizontalScrollContainer>
        </div>
    );
};

export default YatPickerSearchResult;
